import {Component, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelDirective } from '../../directives/panel.directive';
import {TranslatePipe} from "../../filters/translate.pipe";
import RoutingService from "../../services/routing.service";
import RestService from "../../services/core-rest.service";
import AngularHelperService from "../../services/angular-helper.service";
import Session from "../../utils/session.service";
import AngularRoutingHelperService from "../../services/angular-routing-helper.service";
import {
  CardCreatedTrainingProgramComponent
} from "../../components/card-created-training-program/card-created-training-program.component";

@Component({
  standalone: true,
  selector: 'training-programs',
  templateUrl: './training-programs.component.html',
  imports: [CommonModule, PanelDirective, CardCreatedTrainingProgramComponent, TranslatePipe]
})
export default class TrainingProgramsComponent implements OnInit {
  private routingService: RoutingService = inject(RoutingService);
  private restService: RestService = inject(RestService);
  private angularHelperService: AngularHelperService = inject(AngularHelperService);
  private session: Session = inject(Session);
  private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);

  vm: any = undefined;

  constructor() {
    this.vm = this;
  }

  ngOnInit() {
    this.vm.openTrainingLaunch = this.openTrainingLaunch;
    this.routingService.validateAccess('employees').then(() => {});
    this.vm.user = this.session.getSession().user;
    this.angularHelperService.createTimer(() => {
      this.restService.getTrainingPrograms()
          .then((response) => {
            this.vm.programs = response;
          })
          .catch((error) => {
            console.log(error);
          });
    }, 200);

  }

  openTrainingLaunch(programCode) {
    this.angularRoutingHelperService.setPath(`/create-employee-training-program/${programCode}`);
  }

}
